import { Text } from '@mercator-gcp/grout';
import { EmptyField } from 'components/elements/EmptyField';
import { humanReadableArea } from 'utils/format';
import { isNumber } from 'utils/validate';
import type { ProjectSize } from 'types';

type TProps = {
  lotSizeSqft?: ProjectSize['lotsize_sqft'];
};

const LotSize = ({ lotSizeSqft }: TProps) => {
  if (!isNumber(lotSizeSqft) || lotSizeSqft === 0) {
    return <EmptyField />;
  }

  return <Text>{`${humanReadableArea(lotSizeSqft || 0)}`}</Text>;
};

export default LotSize;
